import { IconProps } from './types';

const CrossNonfilledCircleIcon = (props: IconProps) => {
  const { width = '14', height = '14', fillColor = 'var(--grayscale-3)' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <mask
        id="mask0_13840_63097"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="14"
        height="14"
      >
        <rect width="14" height="14" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_13840_63097)">
        <path
          d="M4.4915 9.50573C4.59845 9.61267 4.73456 9.66615 4.89984 9.66615C5.06511 9.66615 5.20123 9.61267 5.30817 9.50573L6.99984 7.81406L8.70609 9.52031C8.81303 9.62726 8.94681 9.6782 9.10742 9.67315C9.26764 9.66848 9.40123 9.61267 9.50817 9.50573C9.61511 9.39878 9.66859 9.26267 9.66859 9.0974C9.66859 8.93212 9.61511 8.79601 9.50817 8.68906L7.8165 6.9974L9.52275 5.29115C9.6297 5.1842 9.68064 5.05042 9.67559 4.88981C9.67092 4.72959 9.61511 4.59601 9.50817 4.48906C9.40123 4.38212 9.26511 4.32865 9.09984 4.32865C8.93456 4.32865 8.79845 4.38212 8.6915 4.48906L6.99984 6.18073L5.29359 4.47448C5.18664 4.36753 5.05306 4.3164 4.89284 4.32106C4.73223 4.32612 4.59845 4.38212 4.4915 4.48906C4.38456 4.59601 4.33109 4.73212 4.33109 4.8974C4.33109 5.06267 4.38456 5.19878 4.4915 5.30573L6.18317 6.9974L4.47692 8.70365C4.36998 8.81059 4.31903 8.94417 4.32409 9.1044C4.32875 9.26501 4.38456 9.39878 4.4915 9.50573ZM6.99984 12.8307C6.19289 12.8307 5.43456 12.6775 4.72484 12.3711C4.01512 12.065 3.39775 11.6495 2.87275 11.1245C2.34775 10.5995 1.93223 9.98212 1.62617 9.2724C1.31973 8.56267 1.1665 7.80434 1.1665 6.9974C1.1665 6.19045 1.31973 5.43212 1.62617 4.7224C1.93223 4.01267 2.34775 3.39531 2.87275 2.87031C3.39775 2.34531 4.01512 1.92959 4.72484 1.62315C5.43456 1.31709 6.19289 1.16406 6.99984 1.16406C7.80678 1.16406 8.56511 1.31709 9.27484 1.62315C9.98456 1.92959 10.6019 2.34531 11.1269 2.87031C11.6519 3.39531 12.0674 4.01267 12.3735 4.7224C12.6799 5.43212 12.8332 6.19045 12.8332 6.9974C12.8332 7.80434 12.6799 8.56267 12.3735 9.2724C12.0674 9.98212 11.6519 10.5995 11.1269 11.1245C10.6019 11.6495 9.98456 12.065 9.27484 12.3711C8.56511 12.6775 7.80678 12.8307 6.99984 12.8307ZM6.99984 11.6641C8.29289 11.6641 9.39403 11.2096 10.3033 10.3008C11.2121 9.39159 11.6665 8.29045 11.6665 6.9974C11.6665 5.70434 11.2121 4.6032 10.3033 3.69398C9.39403 2.78515 8.29289 2.33073 6.99984 2.33073C5.70678 2.33073 4.60584 2.78515 3.697 3.69398C2.78778 4.6032 2.33317 5.70434 2.33317 6.9974C2.33317 8.29045 2.78778 9.39159 3.697 10.3008C4.60584 11.2096 5.70678 11.6641 6.99984 11.6641Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default CrossNonfilledCircleIcon;
